import { fixedCharCodeAt } from "./fixedCharCodeAt";

export function StripNonBMP(str) {
  var newStr = str;
  for (var i = 0; i < str.length; i++) {
    if (fixedCharCodeAt(str, i) > 0xffff) newStr = newStr.replace(str[i] + str[i + 1], "@");
  }
  return newStr;
}
